var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.101,
    height: 70.229,
    viewBox: "0 0 69.101 70.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.082,
    y1: 0.063,
    x2: 1,
    y2: 1.085,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 69.101,
    height: 70.229,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M34.85,12.257V3.01a3.01,3.01,0,0,1,6.02,0v9.247a3.01,3.01,0,0,1-6.02,0m21.071,10.5a3.082,3.082,0,0,0,2.147-.875l6.586-6.538a3,3,0,0,0-4.25-4.234l-6.522,6.522a3.01,3.01,0,0,0,2.1,5.125ZM17.6,53.882,11.065,60.42a3.024,3.024,0,0,0,2.151,5.157,2.972,2.972,0,0,0,2.131-.891l6.538-6.522A3.028,3.028,0,0,0,17.6,53.882m-2.38-15.833a3.011,3.011,0,0,0-3.01-3.01H3.01a3.01,3.01,0,0,0,0,6.02h9.2a3.011,3.011,0,0,0,3.01-3.01m0-26.795a3.016,3.016,0,0,0-4.158,4.094L17.6,21.886a3.025,3.025,0,0,0,2.135.875,3.089,3.089,0,0,0,2.147-.875,3.031,3.031,0,0,0,0-4.25Zm52.895,58.1a3.026,3.026,0,0,1-4.246,0L52.943,58.429,45.181,68.511a3,3,0,0,1-2.38,1.176h-.518a2.979,2.979,0,0,1-2.336-2.055L29.379,34.127a3.015,3.015,0,0,1,3.793-3.793L66.489,41.059a3.013,3.013,0,0,1,.939,5.266L57.334,54.087l10.9,10.9a2.992,2.992,0,0,1,0,4.218ZM50.386,51.891l.2-.173.221-.189,8.244-6.349L36.748,38.049,43.88,60.328Z",
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon7);
export default __webpack_public_path__ + "static/media/social_icon7.29faeb770b7fac239dab87816ce89e37.svg";
export { ForwardRef as ReactComponent };